module.exports = __webpack_public_path__ + "img/datacenter18.de4c8382.png";